import notification from './Notification'

export default notification
